<div class="container">

  <app-header-dialog [iconName]="'ballot'">
    <span>{{local_title}} {{ order_date | date:'dd/MM/yyyy' }} - {{ordered.member_name}}</span>
  </app-header-dialog>

  <div class='content'>

    <mat-card>
      <div class='order-item'>
        <div class='label'>
          Data:
        </div>
        <div class='value'>
          {{ order_date | date:'dd/MM/yyyy' }}
        </div>

      </div>

      <div class='order-item'>
        <div class='label'>
          Produto:
        </div>
        <div class='value'>
          {{ ordered.product_name }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Cliente:
        </div>
        <div class='value'>
          {{ ordered.member_name }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Categoria:
        </div>
        <div class='value'>
          {{ ordered.category_name }}
        </div>
      </div>

      <div class='order-item' *ngIf='ordered.member_debit > 0'>
        <div class='label'>
          Débito:
        </div>
        <div class='value'>
          {{ ordered.member_debit | currency:'BRL':'':'1.2-2' }}
        </div>
      </div>

      <div class='order-item' *ngIf='payment_type_display'>
        <div class='label'>
          Tipo:
        </div>
        <div class='value'>
          {{ payment_type_display }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Origem:
        </div>
        <div class='value'>
          {{ ordered.origin }}
        </div>
      </div>

      <div class='order-item'>
        <div class='label'>
          Tópico:
        </div>
        <div class='value'>
          {{ ordered.topic_name }}
        </div>
      </div>


    </mat-card>


    <mat-card>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Tid</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.Tid"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.Tid.hasError('required')">
          O Tid é obrigatório
        </mat-error>
      </mat-form-field>

      <div style="display: flex;flex-direction: row; justify-content: space-between;">

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Taxa</mat-label>
          <input matInput (blur)='calcValue()' type="number" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.tax" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Débito</mat-label>
          <input matInput (blur)='calcValue()' type="number" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.debit" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Desconto</mat-label>
          <input matInput (blur)='calcValue()' type="number" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.discount" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Valor</mat-label>
          <input matInput (blur)='calcValue()' type="number" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.value" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Total</mat-label>
          <input matInput (blur)='calcValue()' type="number" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.total" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="half-width" appearance="outline">
          <mat-label>Liquido</mat-label>
          <input matInput type="number" (blur)='calcValue()' [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.total_minus_tax" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.total_minus_tax.hasError('required')">
            O Total é obrigatório
          </mat-error>
        </mat-form-field>

      </div>

    </mat-card>

  </div>

  <div class="actions">
    <!--[disabled]="ordered.origin == 'iOS' || ordered.origin == 'Android'"-->
    <button mat-raised-button style='margin-right: 40px;' (click)='delete(ordered)'>
      <mat-icon class='icon-delete'>delete_outline</mat-icon>
    </button>

    <div [ngClass]="{hidden: !_orderedService.spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <!-- [disabled]="ordered.origin == 'iOS' || ordered.origin == 'Android'"-->
    <button *ngIf='!this.new_order' mat-raised-button (click)='updateOrder()'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>